import HistoryContainer from './HistoryContainer';

export default HistoryContainer;
